

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BaseNotificationService } from '../base-notification/base-notification.service';
import { NotificationPublicHealthRecord } from './notification-public-health-record.model';

@Injectable({
    providedIn: 'root'
})
export class NotificationPublicHealthRecordService extends BaseNotificationService<NotificationPublicHealthRecord> {

    constructor(protected http: HttpClient) {
        super(http, 'notificationpublichealthrecord');
    }

}
